<template>
  <div>
    <h1 class="page-header">{{ $t('taxRange.pageTitle') }}</h1>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-6">
            <ts-button color="info" outline @click="createNew">{{ $t('addNew') }}</ts-button>
          </div>
          <div class="col-md-6">
            <form class="form-horizontal">
              <div class="row">
                <label class="col-md-9 col-form-label">{{ $t('taxRange.filter') }} :</label>
                <div class="col-md-3">
                  <select class="form-control" v-model="selectYear" @change="fetchData">
                    <option v-for="(item, index) in year" :key="index" :value="item.taxId">{{ item.text }}</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
        </div>
        <br />
        <div class="row">
          <div class="col-md-3 ts-border-r-2">
            <h5
              class="ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-relative ts-text-blue-700"
              style="padding: 11px;"
            >
              <b>{{ $t('taxRange.actionForm') }}</b>
            </h5>
            <form class="ts-px-4">
              <div class="form-group mt-2">
                <label class="required">{{ $t('taxRange.effectiveDate') }}</label>
                <ts-date-picker-input
                  format="YYYY"
                  v-model="model.effective_year"
                  :class="{ 'is-invalid': errors.has('effective_year') }"
                ></ts-date-picker-input>
                <div class="invalid-feedback" v-if="errors.has('effective_year')">
                  {{ errors.first('effective_year') }}
                </div>
              </div>
              <div class="form-group mt-2">
                <label class="required">{{ $t('taxRange.kidDependent') }}</label>
                <input
                  type="number"
                  v-model.number="model.amount_without_tax"
                  step="any"
                  class="form-control"
                  :class="{ 'is-invalid': errors.has('amount_without_tax') }"
                />
                <div class="invalid-feedback" v-if="errors.has('amount_without_tax')">
                  {{ errors.first('amount_without_tax') }}
                </div>
              </div>
              <div class="form-group mt-2">
                <ts-checkbox v-model="model.is_active">{{ $t('taxRange.active') }}</ts-checkbox>
              </div>
              <div class="mt-2 text-right">
                <ts-button class="btn btn-primary" :waiting="saving" @click.prevent="store">
                  {{ $t('button.save') }}
                </ts-button>
              </div>
            </form>
          </div>
          <div class="col-md-9">
            <ts-table :columns="columns" :records="model.tax_range_list" :loading="loading">
              <template v-slot="{ record, index }">
                <td>
                  <input
                    v-model.number="record.from_amount"
                    type="number"
                    class="form-control only-border-bottom"
                    :class="{ 'is-invalid': errors.has('tax_range_list.' + index + '.from_amount') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('tax_range_list.' + index + '.from_amount')">
                    {{ errors.first('tax_range_list.' + index + '.from_amount') }}
                  </div>
                </td>
                <td>
                  <input
                    v-model.number="record.to_amount"
                    type="number"
                    class="form-control only-border-bottom"
                    :class="{ 'is-invalid': errors.has('tax_range_list.' + index + '.to_amount') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('tax_range_list.' + index + '.to_amount')">
                    {{ errors.first('tax_range_list.' + index + '.to_amount') }}
                  </div>
                </td>
                <td>
                  <input
                    v-model.number="record.percentage"
                    type="number"
                    class="form-control only-border-bottom"
                    :class="{ 'is-invalid': errors.has('tax_range_list.' + index + '.percentage') }"
                  />
                  <div class="invalid-feedback" v-if="errors.has('tax_range_list.' + index + '.percentage')">
                    {{ errors.first('tax_range_list.' + index + '.percentage') }}
                  </div>
                </td>
                <td>
                  <input
                    v-model.number="record.amount_exclude"
                    type="number"
                    class="form-control only-border-bottom"
                    readonly
                  />
                </td>
              </template>
            </ts-table>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'tax-range',
  data() {
    return {
      model: {
        id: '',
        effective_year: '',
        amount_without_tax: '',
        is_active: false,
        tax_range_list: []
      },
      loading: false,
      errors: new Errors(),
      saving: false,
      year: []
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('hr/taxRange', ['resources', 'pagination']),
    columns() {
      return [
        {
          name: this.$t('taxRange.amountFrom'),
          style: 'width:20%'
        },
        {
          name: this.$t('taxRange.amountTo'),
          style: 'width:20%'
        },
        {
          name: this.$t('taxRange.percentage'),
          style: 'width:20%'
        },
        {
          name: this.$t('taxRange.amountExclude'),
          style: 'width:20%'
        }
      ]
    },
    selectYear: {
      get() {
        return this.$store.state.hr.taxRange.taxId
      },
      set(value) {
        this.$store.commit('hr/taxRange/SET_TAX_ID', value)
      }
    }
  },
  methods: {
    ...mapActions('hr/taxRange', ['fetch']),
    formatPrice(value) {
      let val = (value / 1).toFixed().replace(',', '')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    fetchData() {
      this.loading = true
      this.$store
        .dispatch('hr/taxRange/fetch')
        .then(response => {
          this.loading = false
          this.pushRowElement()
          this.pushYearFilter()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
    createNew() {
      ;(this.model.id = 0), (this.model.effective_year = '')
      this.model.amount_without_tax = ''
      this.model.is_active = false
    },
    pushYearFilter() {
      if (this.year.length < this.resources.length) {
        this.year = []
        this.resources.map(el => {
          this.year.push({
            taxId: el.id,
            text: el.effective_year
          })
        })
      }
    },

    pushRowElement() {
      var result = this.resources.length > 1 ? this.resources.filter(a => a.is_active == true) : this.resources
      result.map(main => {
        this.$store.commit('hr/taxRange/SET_TAX_ID', main.id)
        this.model = {
          id: main.id,
          effective_year: main.effective_year,
          amount_without_tax: main.amount_without_tax,
          is_active: main.is_active,
          tax_range_list: []
        }
        main.details.map(el => {
          this.model.tax_range_list.push({
            from_amount: el.from_amount,
            to_amount: el.to_amount,
            percentage: el.percentage,
            amount_exclude: el.amount_exclude
          })
        })
      })
    },
    store() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('hr/taxRange/store', this.model)
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    }
  }
}
</script>

<style lang="css" scoped>
.table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
  cursor: pointer;
}
#tablePayrollTemplate .table > tbody > tr > td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
.only-border-bottom {
  border-top: none;
  border-left: none;
  border-right: none;
}
</style>
